export const tensileTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_started' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.observacao' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.project' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },

  { header: 'generateReport.dataToResult.report.test.tensile.tipo_cp' },
  { header: 'L0' },
  { header: 'generateReport.dataToResult.report.test.tensile.perfil_ensaio' },
  {
    header:
      'generateReport.dataToResult.report.test.tensile.temperatura_ensaio',
  },
  { header: 'generateReport.dataToResult.report.test.tensile.le' },
  { header: 'generateReport.dataToResult.report.test.tensile.rt' },
  { header: 'generateReport.dataToResult.report.test.tensile.al' },
  { header: 'generateReport.dataToResult.report.test.tensile.es' },
  { header: 'generateReport.dataToResult.report.test.tensile.le_rt' },
  {
    header:
      'generateReport.dataToResult.report.test.tensile.temperatura_ensaio_min',
  },
  {
    header:
      'generateReport.dataToResult.report.test.tensile.temperatura_ensaio_max',
  },
  { header: 'generateReport.dataToResult.report.test.tensile.le_min' },
  { header: 'generateReport.dataToResult.report.test.tensile.le_max' },
  { header: 'generateReport.dataToResult.report.test.tensile.rt_min' },
  { header: 'generateReport.dataToResult.report.test.tensile.rt_max' },
  { header: 'generateReport.dataToResult.report.test.tensile.al_min' },
  { header: 'generateReport.dataToResult.report.test.tensile.le_rt_min' },
  { header: 'generateReport.dataToResult.report.test.tensile.le_rt_max' },
  { header: 'generateReport.dataToResult.report.test.tensile.comp_gauge' },
]
